/* src/app/auth/password-rules.scss */
.pw-rules {
  margin: 12px 0 16px;
  padding: 12px 15px;
  background-color: #f5f6fa;
  border-radius: 8px;
  text-align: left;
  font-family: leicht, sans-serif;
  font-size: 13px;
  line-height: 1.45;
  color: #3a3a3a;
}
.pw-rules-title {
  display: block;
  margin-bottom: 6px;
  font-family: halbfett, sans-serif;
  font-weight: 400;
}
.pw-rules-list {
  margin: 0;
  padding: 0;
  list-style: none;
}
.pw-rules-list li {
  display: flex;
  align-items: baseline;
  margin-bottom: 4px;
  padding: 0;
  overflow-wrap: anywhere;
}
.pw-rules-list i {
  flex: 0 0 18px;
  width: 18px;
  color: #a0a0a0;
}
.pw-rules-list .pw-rule-met i {
  color: #1e7e34;
}
.pw-rules-list .pw-rule-unmet i {
  color: #c82333;
}
.pw-rules-note {
  display: block;
  margin-top: 6px;
  color: #6c757d;
}
/*# sourceMappingURL=password-rules-IXSSZU3Y.css.map */
